import { airportCodeToCityNameHe } from "../airportCodeToCityHe";
import { getLdsHotelFromPackage } from "../ldsDealHelpers";
import { resolvePublicPackageCardDestination } from "../resolvePublicPackageCardDestination";
import { formatDiscoveryStayDates } from "./formatDiscoveryStayDates";

/** קוד עיר/שדה (IATA) → שם בעברית; אחרת מחזירים את הקוד רק אם אין תרגום */
function airportCodeToHebrewLabel(code) {
  if (code == null || typeof code !== "string") return "";
  const c = code.trim().toUpperCase();
  if (!c) return "";
  return airportCodeToCityNameHe(c) || c;
}

function ldsFull(deal) {
  return deal?.fullDeal && typeof deal.fullDeal === "object"
    ? deal.fullDeal
    : deal;
}

/**
 * @param {object} deal
 * @param {string} cityCode
 * @param {'package'|'organized'} kind
 */
export function mapLdsDealToDiscoveryCard(deal, cityCode, kind) {
  const full = ldsFull(deal);
  const hotel = getLdsHotelFromPackage(deal);
  const dep =
    full.depDate ||
    full.dep_date ||
    deal.depDate ||
    deal.dep_date ||
    hotel?.checkInDate ||
    hotel?.checkIn;
  const ret =
    full.retDate ||
    full.ret_date ||
    deal.retDate ||
    deal.ret_date ||
    hotel?.checkOutDate ||
    hotel?.checkOut;

  const { rangeLabel, stayLabel } = formatDiscoveryStayDates(dep, ret);
  const destination = resolvePublicPackageCardDestination({
    destinationCode:
      cityCode || full.destinationCode || deal.destinationCode || hotel?.hotelCity,
    hotelCity: hotel?.hotelCity || hotel?.destination,
    destinationHint: hotel?.destination,
  });
  const destHeb = destination.label || String(cityCode || "").trim().toUpperCase();

  const title =
    hotel?.hotelName ||
    hotel?.hotelNameEn ||
    full.tourName ||
    full.packageName ||
    (kind === "organized" ? `טיול מאורגן — ${destHeb}` : `חבילה — ${destHeb}`);

  const subtitle = destHeb;

  const priceDisplay = null;
  if (import.meta.env.DEV && typeof window !== "undefined" && window.__ALLOW_LEGACY_INGEST === true) {
    }

  const imageUrl =
    hotel?.resourceUrl || hotel?.image || hotel?.images?.[0] || null;

  const dealId =
    full.dealId ?? full.hotel?.hotelId ?? `${cityCode}-${dep}-${ret}`;

  return {
    key: `lds-${kind}-${dealId}-${cityCode}`,
    kind,
    imageUrl,
    title: String(title).trim() || "חבילת נופש",
    subtitle: String(subtitle || "").trim(),
    destinationLabel: destHeb,
    destinationCode: destination.destinationCode,
    dateRangeDisplay: rangeLabel,
    staySummaryDisplay: stayLabel,
    priceDisplay,
    packageData: deal,
  };
}

/**
 * תאריכי טיסה מהעסקה או מהחיפוש שביצענו.
 */
export function mapFlightDealToDiscoveryCard(deal, meta) {
  const depSearch = meta?.dep_date;
  const retSearch = meta?.ret_date;
  const leg0 =
    deal?.linkedFlights?.[0]?.flight?.[0]?.leg?.[0] ||
    deal?.linkedFlights?.[0]?.flight?.[0]?.leg;
  const legLast = Array.isArray(deal?.linkedFlights?.[0]?.flight)
    ? deal.linkedFlights[0].flight[deal.linkedFlights[0].flight.length - 1]
        ?.leg?.[0] || deal.linkedFlights[0].flight[deal.linkedFlights[0].flight.length - 1]?.leg
    : null;

  const dep = leg0?.depDate || deal.depDate || depSearch;
  const ret = legLast?.arrDate || legLast?.depDate || deal.retDate || retSearch;

  const { rangeLabel, stayLabel } = formatDiscoveryStayDates(dep, ret);

  const origin = meta?.origin || "TLV";
  const dest = meta?.destination || "";
  const originHeb = airportCodeToHebrewLabel(origin);
  const destHeb = airportCodeToHebrewLabel(dest);
  const title =
    destHeb && originHeb
      ? `${originHeb} ↔ ${destHeb}`
      : originHeb || destHeb || `${origin} ↔ ${dest}`;
  const subtitle = "טיסה הלוך ושוב";

  const priceDisplay = null;
  if (import.meta.env.DEV && typeof window !== "undefined" && window.__ALLOW_LEGACY_INGEST === true) {
    }

  const id =
    deal?.dealId ?? deal?.ID ?? `${origin}-${dest}-${depSearch}-${retSearch}`;
  const depSlug = String(depSearch ?? "").replace(/\//g, "");
  const retSlug = String(retSearch ?? "").replace(/\//g, "");
  /** אותו dealId יכול להופיע בחלונות תאריך שונים — ה-key חייב להבדיל */
  const key =
    deal?.dealId || deal?.ID
      ? `flight-${id}-${depSlug}-${retSlug}`
      : `flight-${id}`;
  const flightId = key;

  return {
    key,
    kind: "flight",
    flightId,
    publicFlightId: flightId,
    imageUrl: null,
    title,
    subtitle,
    dateRangeDisplay: rangeLabel,
    staySummaryDisplay: stayLabel,
    priceDisplay,
    packageData: deal,
    flightRouteMeta: {
      origin,
      destination: dest,
      depDate: depSearch,
      retDate: retSearch,
      adults: 2,
      children: 0,
      infants: 0,
    },
  };
}
